"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecialVendorEventActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["SpecialVendorEvent"] = "SpecialVendorEvent";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var SpecialVendorEventActions;
(function (SpecialVendorEventActions) {
    SpecialVendorEventActions["SpecialVendorCreated"] = "SpecialVendorCreated";
    SpecialVendorEventActions["SpecialVendorUpdated"] = "SpecialVendorUpdated";
    SpecialVendorEventActions["SpecialVendorDeleted"] = "SpecialVendorDeleted";
    SpecialVendorEventActions["CreateSpecialVendor"] = "CreateSpecialVendor";
    SpecialVendorEventActions["UpdateSpecialVendor"] = "UpdateSpecialVendor";
    SpecialVendorEventActions["DeleteSpecialVendor"] = "DeleteSpecialVendor";
})(SpecialVendorEventActions = exports.SpecialVendorEventActions || (exports.SpecialVendorEventActions = {}));
